
<script>
import { defineComponent } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  name: "Autoplay",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
  },
});

function togglePlayPause(videoId) {
  var video = document.getElementById(videoId);
  if (video.paused) {
    video.play();
  } else {
    video.pause();
  }
}

function setVolume(videoId, volume) {
  var video = document.getElementById(videoId);
  video.volume = volume / 100;
}
</script>

<template>
  <Carousel :itemsToShow="1" :autoplay="4500" :wrapAround="true" :transition="500">
    <Slide :id="slide" v-for="slide in count" :key="slide">
      <slot :name="slide">{{ slide }}</slot>
    </Slide>
     <template #addons>
      <Navigation />
    </template>
  </Carousel>
</template>


<style>

.carousel__slide--sliding {
  transition: 0.6s;
}

#carouselStreamers .carousel__slide {
  opacity: 0;
}

#carouselStreamers .carousel__slide--prev {
  opacity: 0;
  z-index: 2;
}

#carouselStreamers .carousel__slide--next {
  opacity: 0;
  z-index: 2;
}

#carouselStreamers .carousel__slide--active {
  opacity: 1;
  z-index: 3;
}

#carouselStreamers button.carousel__prev {
  display: none;
}

#carouselStreamers button.carousel__next {
      right: 11px;
    background-color: #fff;
    border-radius: 50%;
    height: 50px;
    width: 50px;
}
</style>
